import React, { useState, useEffect } from "react";
import { Modal } from "antd";

import { IconBack } from "../../assets/index";
import "./Login.scss";

import RegisterStep1 from "./component/RegisterStep1";
import RegisterStep2 from "./component/RegisterStep2";
import RegisterStep3 from "./component/RegisterStep3";
import ButtonLoginViaGGFB from "../../components/login/ButtonLoginViaGGFB";

const RegisterModal = ({ visible, handleVisible = () => {} }) => {
  const [step, setStep] = useState(1);
  const [dataForm, setDataForm] = useState({});
  useEffect(() => {
    setStep(1);
  }, []);

  const handleChangeStep = (valueStep = 1) => {
    setStep(valueStep);
  };

  const handleChangeDataForm = (data = {}) => {
    setDataForm(data);
  };

  const handleBack = () => {
    setStep(step - 1);
  };

  return (
    <Modal
      title="Đăng ký"
      centered
      visible={visible}
      onCancel={handleVisible}
      className="modal-login"
      width={400}
    >
      {step !== 1 && (
        <div className="btn-back" onClick={handleBack}>
          <IconBack />
        </div>
      )}
      {step === 1 && (
        <>
          <ButtonLoginViaGGFB isLogin={false} />
          <div className="text-des">Hoặc đăng ký bằng số điện thoại</div>
        </>
      )}
      {step === 1 ? (
        <RegisterStep1
          handleChangeStep={handleChangeStep}
          handleVisible={handleVisible}
          dataForm={dataForm}
          handleChangeDataForm={handleChangeDataForm}
        />
      ) : step === 2 ? (
        <RegisterStep2
          handleChangeStep={handleChangeStep}
          dataForm={dataForm}
          handleChangeDataForm={handleChangeDataForm}
        />
      ) : (
        <RegisterStep3
          handleChangeStep={handleChangeStep}
          dataForm={dataForm}
          handleChangeDataForm={handleChangeDataForm}
        />
      )}
    </Modal>
  );
};

export default RegisterModal;
